module.exports = __webpack_public_path__ + "static/media/trending.a85d3304.svg";